import axios from "axios";

const state = {
  user: null,
  kitlog:{},
  locations:[],
  items:[],
  remaining: {},
  inventory: {},
  location:null,
  item:null,
  invsearchstr:null,
  pagination:0,
  page:1,
  maxkit:0,
  invkit:false,
  isLoading:false,
  kitCounts: {
    amazon: {},
    idlife: {},
    amazonSum: 0,
    idlifeSum: 0,
  },
  fbaCount:{},
  amazonFba:{}
};

const mutations = {
  setUser(store, data) {
    store.user = data;
  },
  setkitLog(state, data) {
    state.kitlog = data;
  },
  setLocations(state, data) {
    state.locations = data;
  },
  setFillocation(state, data) {
    state.location = data;
  },
  setFilItem(state, data) {
    state.item = data;
  },
  setRemaining(state, data) {
    state.remaining = data;
  },
  setInventory(state, data) {
    state.inventory = data;  
  },
  setPagination(state, data) {
    state.pagination = data;  
  },
  setPage(state, data) {
    state.page = data;  
  },
  setMaxKit(state, data) {
    state.maxkit = data;  
  },
  setInvSearchString(state, data) {
    state.invsearchstr = data;  
  },
  setitems(state, data) {
    state.items = data;  
  },
  setInvKits(state, data) {
    state.invkit = data;  
  },
  setInvOrderBy(state, data) {
    state.setInvOrderBy = data;
  },
  setInvSortedBy(state, data) {
    state.setInvSortedBy = data;
  },
  setLoader(state, isLoading) {
    state.isLoading = isLoading;
  },
  setKitCounts(state, data) {
    state.kitCounts.amazon = data.amazon;
    state.kitCounts.idlife = data.idlife;
    state.kitCounts.amazonSum = data.amazonSum;
    state.kitCounts.idlifeSum = data.idlifeSum;
  },
  setFbaKitCounts(state, data) {
    state.fbaCount = data;
  },
  setAmazonFba(state, data) {
    state.amazonFba = data;
  },
};

const actions = {
  getKitLog({ commit }, data) {
    return axios.get(
      `/v1/admin/kitLog?kit_id=${data}`
    ).then( res => {
        commit("setkitLog",res.data.data.query);
    })
  },
  setInvKits({ commit }, data) {
    commit("setInvKits", data);
  },
  setPage({ commit }, data) {
    commit("setPage", data);
  },
  setPagination({ commit }, data) {
    commit("setPagination", data);
  },
  setInvSearchString({ commit },data) {
    commit("setInvSearchString", data);
  },
  setFillocation({ commit },data) {
    commit("setFillocation", data);
  },
  setFilItem({ commit },data) {
    commit("setFilItem", data);
  },
  editInv({ commit },data) {
    let url =  `/v1/admin/editInv`;
    return axios.post(url,data).then(res => {
      return res;
    })
  },

  calculateKitCountsByPercentage({ commit, dispatch }, data) {
    return axios.post("/v1/admin/calculateKitCountsByPercentage", data).then(res => {
      commit("setRemaining", res.data.data.remaining);
      return res.data;
    });
  },

  setRemaining({ commit }, data) {
    commit("setRemaining", data);
  },

  setInventory({ commit }, params = {}) {
    let url =  `/v1/admin/inventory?per_page=100`;

    const loc = params.location || state.location;
    if (loc) {
      url += `&location=${encodeURIComponent(loc)}`;
    }

    const search = params.search || state.invsearchstr;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }

    if (params.brand) {
      url += `&brand=${encodeURIComponent(params.brand)}`;
    }

    if (params.stock_status) {
      url += `&stock_status=${encodeURIComponent(params.stock_status)}`;
    }

    if (state.page !== null) {
      url += `&page=${state.page}`;
    }

    return axios.get(url).then(res => {
      let inventory = res.data.data;
      if (Array.isArray(inventory)) {
        inventory = inventory.map(element => {
          let price = element.units_per_price;
          if (price === null || price === undefined || price === '' || isNaN(parseFloat(price))) {
            price = '0.00';
          } else {
            price = parseFloat(price).toFixed(2);
          }
          element.units_per_price = price;
          if(Object.keys(state.remaining).length > 0 && state.remaining[element.sku] !== undefined) {
            element.total_inventory = parseFloat(element.available_inventory || 0);
            element.reserved = element.total_inventory - state.remaining[element.sku];
            element.available_inventory = state.remaining[element.sku];
            element.total_price = parseFloat((parseFloat(element.units_per_price) * element.reserved).toFixed(2));
          } else {
            element.total_price = parseFloat((parseFloat(element.units_per_price) * parseFloat(element.available_inventory || 0)).toFixed(2));
          }
          return element;
        });
      }
      commit("setInventory", inventory);
      return inventory;
    });
  },
  setLocations({ commit, getters }) {
    return axios.get("/v1/admin/location").then(res => {
      commit("setLocations", res.data.data.location);
    });
  },
  setItems({ commit, getters }) {
    return axios.get("/v1/admin/item").then(res => {
      commit("setitems", res.data.data.item);
    });
  },
  checkKitIdProfile({ commit, getters, dispatch }, kitId) {
    commit("setLoader", true);
    // Drop any stale errors from a previous attempt so the activation modal
    // does not flash a "Kit ID does not exist" carried over from the prior
    // submission.
    commit("clearServerValidationErrors");
    // Fetch tempuser prefill data in parallel (same as V1 checkKitId).
    // testuserdetails already swallows its own rejection so a 404 here cannot
    // bubble up and reject this action � the preview POST is the authority.
    dispatch("testuserdetails", kitId.kit_id);
    return axios.post("/v1/customer/testkits/preview", kitId).then(res => {
      commit("updateUserInfo", res.data.data.testkit);
      if (res.data.data.kit_version) {
        commit("setKitVersionProfile", res.data.data.kit_version);
      }
      commit("setLoader", false);
    }).catch(error => {
      commit("setLoader", false);
      return Promise.reject(error);
    });
  },
  associateKitId({ commit }, kitId) {
    commit("setLoader", true);
    return axios.post("/v1/customer/testkits/associate", kitId).then(res => {
      commit("updateUserInfo", res.data.data.testkit);
      commit("setLoader", false);
    });
  },
  async sendVerifyCodeProfile({ commit, getters, dispatch }, code) {
    const notifications = {
      notifications_sms: false,
      notifications_email: false,
      phone: getters.contacts.phone,
      email: getters.contacts.mail
    };
    if ("phone" in code) {
      const response = await axios.post("/v1/profile/confirm/phone", code);
      commit("setUser", response.data.data.user);
      return response;
      // .then((res) => {
      //   commit('updateUserInfo', {data: 'data'})
      //   commit('changeUserInfo', res.data.data.user);
      //   return true
      // });
    } else {
      const response = await axios.post("/v1/profile/confirm/email", code);
      commit("setUser", response.data.data.user);
      return response;
      // .then((res) => {
      //   commit('updateUserInfo', {data: 'data'})
      //   commit('changeUserInfo', res.data.data.user);
      //   return true
      //   // commit('updateUserInfo', res.data.data.user);
      //   // notifications.notifications_email = true;
      //   // commit('updateUserInfo', notifications);
      //   // commit('verifyEmail', false);
      // })
    }
  },
  async changeProfile({ commit }, data) {
    commit("setLoader", true);
    try {
      const response = await axios.put("/v1/profile", data);
      commit("setUser", response.data.data.user);
      commit("setLoader", false);
      return response;
    } catch (error){
      if(error.response.data.error == 'ValidationException'){
        if(!error.response.data.data.messages.success){
          return error.response.data.data.messages.errors[0];
        }
      }
    }
  },
  async updateCustomer({ commit , dispatch}, data) {
    commit("setLoading", true);
    try {
      const response = await axios.put("/v1/editCus", data);
      dispatch("getContactCustomers");
      commit("setLoading", false);
      return response;
    } catch (error) {
      if(error.response.data.error == 'ValidationException'){
        if(!error.response.data.data.messages.success){
          return error.response.data.data.messages.errors[0];
        }
      }
    }
  },
  async profile({ commit }, data) {
    try {
      const response = await axios.get("/v1/profile");
      commit("setUser", response.data.data.user);
      commit("updateUserInfo", response.data.data.user);
      return response.data.data.user;
    } finally {
      commit("setLoader", false);
    }
  },
  changePasswordProfile({ commit }, data) {
    commit("setLoader", true);
    return axios.put("/v1/password/update", data).then(res => {
      commit("setLoader", false);
    });
  },
  savereportemail({ commit }, data) {
    commit("setLoader", true);
    return axios.post("/v1/reportemail/update", data).then(res => {
      commit("setLoader", false);
    });
  },
  setAmazonIdel({ commit,rootState }) {
    commit("setLoader", true);
     let url = "";
     const days = rootState.admin.days;
     const payment = rootState.admin.payment;
    if (days !== null) {
      if (url === "") {
        url += `days=${days}`;
      } else {
        url += `&days=${days}`;
      }
    }
    if (payment !== "") {
      if (url === "") {
        url += `payment=${payment}`;
      } else {
        url += `&payment=${payment}`;
      }
    }
    return axios.get(`/v1/admin/amazonIdel?${url}`).then(res => {
      commit('setKitCounts', res.data);
      commit("setLoader", false);
    });
  },
  async setAmazonFbaInv({ commit }) {
    commit("setLoader", true);
    return axios.get(`/v1/admin/getAmazonFBA`).then(res => {
      if(res.data.data.length > 0){
        commit('setAmazonFba', res.data.data);
        // console.log(res.data.data);
        const result = res.data.data.map(item => {
            let key = null;
        
            if (item.sellerSku.includes("Refill")) {
                // Handle the Refill case
                const match = item.sellerSku.match(/Refill-(\d+)-Room/);
                if (match) {
                    const count = match[1]; // Extracted number
                    key = `R${count}`; // Key in format R1, R2, etc.
                }
            } else {
                // Handle the non-Refill case
                const match = item.productName.match(/(\d+)\sROOM\sKIT/);
                if (match) {
                    const count = match[1]; // Extracted number
                    key = `F${count}`; // Key in format F1, F2, etc.
                }
            }
        
            if (key) {
                return { [key]: item.totalQuantity };
            }
        
            return null; // Return null if no matching pattern is found
        }).filter(item => item !== null); // Filter out null values
        const order = ['F1', 'F2', 'F3', 'R1', 'R2', 'R3'];
        const sortedData = result.sort((a, b) => {
            const aKey = Object.keys(a)[0]; // Extract key from first object
            const bKey = Object.keys(b)[0]; // Extract key from second object
        
            // Compare the index of the keys in the 'order' array
            return order.indexOf(aKey) - order.indexOf(bKey);
        });
        commit('setFbaKitCounts', sortedData);
        commit("setLoader", false);
      }
    });
  },
};

const getters = {
  currentUser() {
    // Variable to hold the user variables
    var currentUser = state.user;
    // Sort the testkits by id's to have an homogeneous presentation x platforms.
    if (currentUser.testkits) {
      currentUser.testkits.sort((a, b) => {
        return a.id - b.id;
      });
    }
    if (currentUser.kits_v2) {
      currentUser.kits_v2.sort((a, b) => {
        return a.id - b.id;
      });
    }
    return currentUser;
  },
  getkitLogData(){
     return state.kitlog;
  },
  getLocation() {
    return state.locations ;
  },
  getItem() {
    return state.items ;
  },
  getInventory(){
    return  state.inventory;
  },
  getPaginations() {
    return state.pagination;  
  },
  getMaxKit() {
    return state.maxkit;  
  },
  getInvKit() {
    return state.invkit;  
  },
  getFillocation() {
    return state.location;
  },
  getFilItem() {
    return state.item;
  },
  getKitCounts() {
    return state.kitCounts;
  },
  getFbaKitCounts() {
    return state.fbaCount;
  },
  getAmazonFba() {
    return state.amazonFba;
  }
  
};

export default {
  state,
  mutations,
  actions,
  getters
};
